import axios from 'axios'
import {useUserStore} from '@/stores'
import {useAsyncState} from '@vueuse/core'
import {computed, watch} from 'vue'

const env = import.meta.env
const environment: string | undefined = (window as any).getEnvironmentFromURL()

const getApiUrl = (endpoint: string, environment?: string) => {
  if (environment) {
    if (environment === 'prod') {
      return endpoint.replace('{{environment}}', '')
    }
    return endpoint.replace('{{environment}}', `${environment}.`)
  }
  return endpoint
}

// VITE_API_URL is optional in the env typings but always set for a build
const apiUrl = () => getApiUrl(env.VITE_API_URL as string, environment)
const stringSend = (length: number) => [...Array(length)].map(() => Math.random().toString(36)[2]).join('')
const dataSend = stringSend(Number(env.VITE_NUMBER_OF_CHARACTER_UPLOAD))
const startTime = performance.now()
export default function usePreCallSpeed() {
  const user: any = useUserStore()
  const {isLoading: uploadLoading, state: uploadSpeed} = useAsyncState(async () => {
    await axios.post(`${apiUrl()}/api/public/network/uploadSpeed`, dataSend)
    return (dataSend.length * 8) / ((performance.now() - startTime) / 1000) / 1024
  }, 0)
  watch(uploadSpeed, speed => user.setNetworkSpeed({uploadSpeed: speed.toFixed(2)}))

  const {isLoading: downloadLoading, state: downloadSpeed} = useAsyncState(async () => {
    const {data} = await axios.post(`${apiUrl()}/api/public/network/downloadSpeed`, {})
    const endTime = performance.now()
    const byteLength = new TextEncoder().encode(JSON.stringify(data)).length
    return (byteLength * 8) / ((endTime - startTime) / 1000) / 1024
  }, 0)
  watch(downloadSpeed, speed => user.setNetworkSpeed({downloadSpeed: speed.toFixed(2)}))
  const validatingSpeed = computed(() => uploadLoading.value || downloadLoading.value)
  const slowNetwork = computed(() => {
    const speedThreshold = Number(env.VITE_UPLOAD_DOWNLOAD_SPEED_AVERAGE) || 1024
    let slowNetwork = false
    if (downloadSpeed.value) {
      return downloadSpeed.value < speedThreshold
    }
    if (uploadSpeed.value) {
      return uploadSpeed.value < speedThreshold
    }
    return slowNetwork
  })
  return {validatingSpeed, slowNetwork}
}
